import api from '@/libs/axios'

export default {
  getLicensingAgencies: () => api.get('/system/licensing-agency'),
  getLicensingAgencyById: id => api.get(`/system/licensing-agency/${id}`),
  editLicensingAgency: form => api.patch(`/system/licensing-agency/${form.id}`, form),
  createLicensingAgency: form => api.post('/system/licensing-agency', form),
  deleteLicensingAgencies: array => api.delete('/system/licensing-agency', array),
}
